import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-ledger-calculator',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ledger-calculator.component.html',
  styleUrl: './ledger-calculator.component.css'
})
export class LedgerCalculatorComponent {
  ledgerEntries: any = [];
  currentActiveOp = '+';
  savedStateKey = 'calc_storage';

  // DOM Elements Selection
  ledgerRowsContainer: any = '';
  calcInput: any = null;
  nextOperatorLabel: any = '';
  ledgerLiveTotal: any = '';
  boxGrandTotal: any = '';
  boxLastRowTotal: any = '';
  roundPrecisionInput: any = '';

  // Trigger elements
  btnCalculate: any = '';
  btnClear: any = '';
  btnSave: any = '';
  btnRestore: any = '';

  ngOnInit() {
    // DOM Elements Selection
    this.ledgerRowsContainer = document.getElementById('ledgerRows');
    let calcInputZ = document.getElementById('calcInput');
    this.nextOperatorLabel = document.getElementById('nextOperator');
    this.ledgerLiveTotal = document.getElementById('ledgerLiveTotal');
    this.boxGrandTotal = document.getElementById('boxGrandTotal');
    this.boxLastRowTotal = document.getElementById('boxLastRowTotal');
    this.roundPrecisionInput = document.getElementById('roundPrecision');

    // Trigger elements
    this.btnCalculate = document.getElementById('btnCalculate');
    this.btnClear = document.getElementById('btnClear');
    this.btnSave = document.getElementById('btnSave');
    this.btnRestore = document.getElementById('btnRestore');

    this.renderLedger();
    calcInputZ?.focus();

    setInterval(()=>{
      calcInputZ?.focus();
    },1000);
  }

  // Numbers Precision Formatter utility
  formatValue(value: any) {
    const precision = parseInt(this.roundPrecisionInput.value, 10) || 0;
    return value.toLocaleString('en-US', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
    });
  }

  // Engine Rendering Loop Update
  renderLedger() {
    this.ledgerRowsContainer.innerHTML = '';
    let rollingTotal = 0;
    this.ledgerEntries.forEach((entry: any, idx: number) => {
        // Calculation Logic step allocation processing
        const currentVal = parseFloat(entry.val) || 0;
        if (idx === 0 || entry.op === ' ' || entry.op === '+') {
            rollingTotal += currentVal;
        } else if (entry.op === '-') {
            rollingTotal -= currentVal;
        } else if (entry.op === '*') {
            rollingTotal *= currentVal;
        } else if (entry.op === '/') {
            if (currentVal !== 0) rollingTotal /= currentVal;
        }
        // DOM Node Generation
        const rowDiv = document.createElement('div');
        rowDiv.className = 'ledger-row d-flex justify-content-between px-2';
        const opSpan = document.createElement('div');
        opSpan.className = 'ledger-op';
        opSpan.textContent = entry.op;
        const valSpan = document.createElement('div');
        valSpan.className = 'ledger-val';
        // Inline editing element config
        const valInput = document.createElement('input');
        valInput.type = 'text';
        valInput.value = this.formatValue(entry.val);
        valInput.style.border = 'none';
        valInput.style.background = 'transparent';
        valInput.style.textAlign = 'right';
        valInput.style.width = '100%';
        valInput.style.fontFamily = 'inherit';
        valInput.style.fontSize = 'inherit';
        valInput.style.outline = 'none';
        // Inline modifications handling updates directly
        valInput.addEventListener('change', (e: any) => {
            const parsed = parseFloat(e.target.value.replace(/,/g, ''));
            if (!isNaN(parsed)) {
                this.ledgerEntries[idx].val = parsed;
            }
            this.renderLedger();
        });
        valInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                valInput.blur();
                // this.calcInput.focus();
            }
        });
        valSpan.appendChild(valInput);
        rowDiv.appendChild(opSpan);
        rowDiv.appendChild(valSpan);
        this.ledgerRowsContainer.appendChild(rowDiv);
    });
    // Output panels calculations syncing
    this.ledgerLiveTotal.textContent = this.formatValue(rollingTotal);
    this.boxGrandTotal.textContent = this.formatValue(rollingTotal);
    this.boxLastRowTotal.textContent = this.formatValue(rollingTotal);
    // Auto-scroll inside list context tracking focus placement
    this.ledgerRowsContainer.scrollTop = this.ledgerRowsContainer.scrollHeight;
  }

  // Core Value Input Submission Handling Functions
  commitCurrentEntry() {
    const rawVal = this.calcInput.trim();
    if (rawVal === '') return;
    const parsedVal = parseFloat(rawVal);
    if (!isNaN(parsedVal)) {
      this.ledgerEntries.push({
        op: this.currentActiveOp,
        val: parsedVal
      });
      this.calcInput = '';
      this.currentActiveOp = '+'; // Default fallback back to addition sequence state tracking
      this.nextOperatorLabel.textContent = this.currentActiveOp;
      this.renderLedger();
    }
  }

  // Intercepting Key Actions inside Input Context Bounds
  calcInput_keydown(e: any) {
    const operationalKeys = ['+', '-', '*', '/'];
    if (operationalKeys.includes(e.key)) {
      e.preventDefault(); // Suppress printing symbol value directly into entry element field
      if (this.calcInput.trim() !== '') {
        this.currentActiveOp = e.key;
        this.commitCurrentEntry();
      } else if (this.ledgerEntries.length > 0) {
        // Change sequence parameter updates directly on empty input transitions
        this.currentActiveOp = e.key;
        this.nextOperatorLabel.textContent = this.currentActiveOp;
      }
    } else if (e.key === 'Enter') {
      e.preventDefault();
      this.commitCurrentEntry();
    }
  }

  // Explicit calculation pipeline refresh enforcement manual activation
  calculate_click() {
    this.commitCurrentEntry();
    this.renderLedger();
    // this.calcInput.focus();
  }

  // UI System Cleanup Configuration Action Tasks
  clear_click() {
    this.ledgerEntries = [];
    this.calcInput = '';
    this.currentActiveOp = '+';
    this.nextOperatorLabel.textContent = this.currentActiveOp;
    this.renderLedger();
    // this.calcInput.focus();
  }

  // State Persistence Pipeline Config Actions
  save_click() {
    localStorage.setItem(this.savedStateKey, JSON.stringify(this.ledgerEntries));
    alert('Ledger states saved successfully.');
    // this.calcInput.focus();
  }

  restore_click() {
    const restored = localStorage.getItem(this.savedStateKey);
    if (restored) {
      this.ledgerEntries = JSON.parse(restored);
      this.renderLedger();
    } else {
      alert('No previous calculation logs tracking found inside session contexts.');
    }
    // this.calcInput.focus();
  }

}
